import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VModal from 'vue-js-modal'

import VueProgressiveImage from 'vue-progressive-image'
import store from './store'
import VueClipboard from 'vue-clipboard2'

import './styles/main.less'

import Vue2TouchEvents from 'vue2-touch-events'
import VueOnlinePlugin from 'vue-navigator-online'

Vue.use(VueOnlinePlugin)

Vue.use(Vue2TouchEvents)

Vue.use(VueClipboard)
Vue.use(VueProgressiveImage)
Vue.config.productionTip = false
Vue.use(VModal, { dialog: true, dynamic: true, dynamicDefaults: { clickToClose: true } })

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
